import React, { useEffect, useState } from 'react';
import navLogo from '../../assets/lovedripp.png';
import { Link } from 'react-router-dom';
import './topnavigation.css';
import { useSelector } from 'react-redux';
import { FaBars, FaWindowClose } from "react-icons/fa";

function TopNavigation({title, classBack}) {

  const {user}                                  = useSelector((state) => state.auth);

  const [isMobile, setIsMobile]                 = useState(false);
  const [showMobileMenu, setShowMobileMenu]     = useState(false);

  useEffect(() => {
    // Function to check screen width and update state
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    // Initial check when the component mounts
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

    const menuClass = `d-flex menu-list ${isMobile ? 'overlay-menu togglevew' + showMobileMenu : ''}`.trim();
  return (
    <header className={"navbar navbar-expand-lg bd-navbar sticky-top " + classBack} > 
      <nav className="container-fluid">        
          <Link to={"/"} className="navbar-brand">
              <img src={navLogo} className="logo-nav" />
          </Link>

          <button className="btn btn-mobile-view" onClick={() => setShowMobileMenu(true)}>
            <FaBars />
          </button>
          
          <div className={menuClass} role="search">
             <button className="btn btn-white btn-close-menu" onClick={() => setShowMobileMenu(false)}>
              <FaWindowClose />
             </button>
            <div className="item-nav">
                <Link to={"/"} className="nav-link">Home</Link>
            </div>
            <div className="item-nav">
                <Link to={"/onsites"} className="nav-link">Onvites</Link>
            </div>
            <div className="item-nav">
                <Link to={"/annisites"} className="nav-link">Annisites</Link>
            </div>
            <div className="item-nav">
                <Link to={"/how-to"} className="nav-link">How To</Link>
            </div>
            {
              isMobile && (
                <>
                  <div className="item-nav">
                      <Link to={"/blogs"} className="nav-link">Blogs</Link>
                  </div>
                  <div className="item-nav">
                      <Link to={"/about"} className="nav-link">About</Link>
                  </div>
                  <div className="item-nav">
                      <Link to={"/contact-us"} className="nav-link">Contact Us</Link>
                  </div>                  
                </>
              )
            }
            <div className="item-nav">                
                  {
                    !user ?   
                      <Link className="nav-link bnt-nav-link" to={"/authenticate"}>Authenticate</Link>
                    : <Link className="nav-link btn-nav-link" to={"/profile"}>
                        {user.name}
                        <div className="sm-prof">Profile</div>
                      </Link>
                  }             
            </div>
          </div>     
      </nav>
      
   </header>
  )
}

export default TopNavigation